import React from 'react';
import { useProjectAppLoading } from '../../../providers/ProjectAppViewLoadingProvider';

interface ProjectAppTabSpinnerProps {
  appId: string;
}

const ProjectAppTabSpinner: React.FC<ProjectAppTabSpinnerProps> = ({
  appId,
}) => {
  const { isLoading } = useProjectAppLoading();

  if (!isLoading(appId)) return null;

  return <span className='tab-spinner' aria-label='Updating' />;
};

export default React.memo(ProjectAppTabSpinner);
